type PropertyCoverProps = {
  type?: string;
  location?: string;
  reference?: string;
  size?: "card" | "hero" | "compact";
};

const wash = `
  radial-gradient(120% 90% at 100% 110%, rgba(162,104,80,0.55) 0%, rgba(111,83,39,0.12) 32%, transparent 58%),
  radial-gradient(90% 70% at 0% -10%, rgba(86,80,62,0.4) 0%, transparent 46%),
  linear-gradient(165deg, #1c1814 0%, #100e0c 46%, #070605 100%)
`;

export default function PropertyCover({
  type,
  location,
  reference,
  size = "card",
}: PropertyCoverProps) {
  const line = [type, location].filter(Boolean).join(" · ");
  const logoClass =
    size === "hero" ? "w-40 sm:w-52" : size === "compact" ? "w-24" : "w-32 sm:w-36";
  const lineClass =
    size === "hero"
      ? "mt-6 max-w-md text-sm tracking-[0.2em] sm:text-base"
      : size === "compact"
        ? "mt-3 max-w-[14rem] text-[11px] tracking-[0.16em]"
        : "mt-5 max-w-[18rem] text-xs tracking-[0.18em] sm:text-sm";

  return (
    <div className="absolute inset-0 overflow-hidden bg-[#100e0c]">
      <div className="absolute inset-0" style={{ background: wash }} />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_40%,rgba(0,0,0,0.28)_100%)]" />
      <div className="relative flex h-full w-full flex-col items-center justify-center px-6 text-center">
        <img src="/logo.webp" alt="DEM Properties" className={logoClass} />
        {line && (
          <p className={`font-oswald uppercase text-[#F8F5EF]/80 ${lineClass}`}>{line}</p>
        )}
        {reference && size === "hero" && (
          <p className="mt-3 font-oswald text-xs uppercase tracking-[0.22em] text-[#a26850]">
            {reference}
          </p>
        )}
      </div>
    </div>
  );
}
